import { requiredRoles } from '@/shared/utils/require-roles'
import { UserRole } from '@depanneo/types'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/technicians/new'
)({
  beforeLoad() {
    requiredRoles([UserRole.SUPER_ADMIN])
  },
})
